import { Component, Input } from '@angular/core';
import { ICardStrategyDTO } from '@hub-workspace/apps/logged-home/src/app/shared/interfaces/card-strategy';

@Component({
    selector: 'app-card-strategy',
    templateUrl: './card-strategy.component.html',
    styleUrls: ['./card-strategy.component.scss']
})
export class CardStrategyComponent {

    @Input()
    public strategy: ICardStrategyDTO;

    public get strategyCoverUrl() {
        return this.strategy.coverUrl || this.strategy.coverMobileUrl || '/home/assets/draws/home/doubt-illustration-with-floor.svg';
    }

}
